import { R } from '@core/utils/r';
import {
  CompactJournalResponse,
  JournalId,
  JournalQuery,
  JournalRequest,
  JournalResponse,
  ProgressMetricsResponse,
} from '@business/entities/journal';
import { Endpoint } from '@business/api/endpoint';
import { Paginate } from '@business/entities/common';

export function fetchJournals(options: JournalQuery) {
  const params = R.objectCompact({
    ...options,
    page: options.page || 1,
    perPage: options.perPage || 20,
  });
  return Endpoint.get<Paginate<CompactJournalResponse>>(`@gc/ai-feeds`, { params });
}

export function createJournal(data: JournalRequest) {
  return Endpoint.post<CompactJournalResponse>(`@gc/ai-feeds`, { data: R.objectCompact(data) });
}

export function updateJournal(journalId: JournalId, data: JournalRequest) {
  return Endpoint.patch<CompactJournalResponse>(`@gc/ai-feeds/${journalId}`, { data });
}

export function deleteJournal(journalId: JournalId) {
  return Endpoint.delete<void>(`@gc/ai-feeds/${journalId}`);
}

export function fetchJournal(journalId: JournalId) {
  return Endpoint.get<JournalResponse>(`@gc/ai-feeds/${journalId}`);
}

export function likeJournal(journalId: JournalId) {
  return Endpoint.post<CompactJournalResponse>(`@gc/ai-feeds/like/${journalId}`);
}

export function dislikeJournal(journalId: JournalId) {
  return Endpoint.post<CompactJournalResponse>(`@gc/ai-feeds/dislike/${journalId}`);
}

export function fetchProgressMetrics(dateRange?: string) {
  return Endpoint.get<ProgressMetricsResponse>(`@gc/ai-feeds/progress-metrics`, {
    params: { dateRange },
  });
}
